import { USER_TYPES } from '../constants/user';

/**
 * @param {string} featureKey Key in `client_config`.
 * @param {Object} params
 * @param {Object} [params.clientConfig]
 * @param {string} [params.userRole]
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureKey, { clientConfig, userRole }) =>
  userRole === USER_TYPES.superuser || clientConfig?.[featureKey] === true;

/**
 * @param {Object} route
 * @param {string|string[]} [route.pageClassification]
 * @param {Object} params
 * @param {Object} [params.clientConfig]
 * @param {string} [params.userRole]
 * @returns {boolean}
 */
export const isClassificationEnabled = (route, params) =>
  !route.pageClassification ||
  [route.pageClassification]
    .flat()
    .some((featureKey) => isFeatureEnabled(featureKey, params));

/**
 * @param {string[]|string} [userTypes]
 * @returns {{farmer_enabled: boolean, field_agent_enabled: boolean}}
 */
export const getUserTypeFlags = (userTypes) => {
  const types = [userTypes]
    .flat()
    .filter(Boolean)
    .map((t) => t.toLowerCase());
  return {
    farmer_enabled: types.includes('farmer'),
    field_agent_enabled: types.includes('field-agent'),
  };
};
